import { isSite } from '../store/basic-params/basic-params-selectors';

export const isCreatePostButtonVisible = (state, canSee) => isSite(state) && canSee('create', 'post');
